<template>
  <b-row>
    <!-- dekstop -->
    <b-col class="d-none d-sm-block">
      <b-row>
        <b-col>
          <span style="font-size: 2em; font-weight: 500;">{{ welcome_text }}!</span>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <span style="font-size: 1.2em;">
            We will find you a Guide in
          </span>
          <span class="editable-text" style="font-size: 1.5em; font-weight: 500;" @click="changeCountryCity" v-b-tooltip.hover.bottom title="edit city">
            {{ order_data.country_text }}, {{ order_data.city_text }}
          </span>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <span style="font-size: 1.2em;">
            You'll be traveling on
          </span>
          <span class="editable-text" style="font-size: 1.4em; font-weight: 500;" @click="changeDate" v-b-tooltip.hover.bottom title="edit date">
            {{ order_data.start_date_text }} - {{ order_data.end_date_text }}
          </span>
          <span style="font-size: 1.2em;">
            and your interested in
          </span>
          <span class="editable-text" style="font-size: 1.5em; font-weight: 500;" @click="changeInterest" v-b-tooltip.hover.bottom title="edit interest">
            {{ order_data.interest_text }}
          </span>
        </b-col>
      </b-row>
    </b-col>

    <!-- mobile -->
    <b-col class="d-block d-sm-none">
      <b-row>
        <b-col>
          <span style="font-size: 1.2em; font-weight: 500;">{{ welcome_text }}!</span>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <span style="font-size: 0.9em;">
            We will find you a Guide in
          </span>
          <span class="editable-text" style="font-size: 1em; font-weight: 500;" @click="changeCountryCity" v-b-tooltip.hover.bottom title="edit city">
            {{ order_data.country_text }}, {{ order_data.city_text }}
          </span>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <span style="font-size: 0.9em;">
            You'll be traveling on
          </span>
          <span class="editable-text" style="font-size: 1em; font-weight: 500;" @click="changeDate" v-b-tooltip.hover.bottom title="edit date">
            {{ order_data.start_date_text }} - {{ order_data.end_date_text }}
          </span>
          <span style="font-size: 0.9em;">
            and your interested in
          </span>
          <span class="editable-text" style="font-size: 1em; font-weight: 500;" @click="changeInterest" v-b-tooltip.hover.bottom title="edit interest">
            {{ order_data.interest_text }}
          </span>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_Header',
  props: ['order_data'],
  created: function () {
    if (this.order_data.country === '5ccd68bcba49fad2ae76ee2f') this.welcome_text = 'Salut' // Perancis
    else if (this.order_data.country === '5ccd68bcba49fad2ae76ee1d') this.welcome_text = 'Hallo' // Jerman
    else if (this.order_data.country === '5ccd68bcba49fad2ae76ee31') this.welcome_text = 'Hello' // Inggris
    else if (this.order_data.country === '5ccd68bcba49fad2ae76ee52') this.welcome_text = 'Ciao' // Itali
    else if (this.order_data.country === '5ccd68bcba49fad2ae76eec3') this.welcome_text = 'Merhaba' // Turki
    else if (this.order_data.country === '5d4d91e9bab1d9edcb9d7cff') this.welcome_text = 'Hallo' // Belanda
    else if (this.order_data.country === '5d4d91e9bab1d9edcb9d7d03') this.welcome_text = 'Hello' // Australia
    else if (this.order_data.country === '5d4d91e9bab1d9edcb9d7d07') this.welcome_text = '嗨' // Tiongkok
    else if (this.order_data.country === '5d4d91e9bab1d9edcb9d7d0c') this.welcome_text = 'Hi' // AS
    else if (this.order_data.country === '5d529661655a43f9d26a040a') this.welcome_text = 'Hello' // Kanada
    else if (this.order_data.country === '5d529661655a43f9d26a040d') this.welcome_text = '嗨' // Taiwan
    else if (this.order_data.country === '5d8adff0343cb83569b448a6') this.welcome_text = 'こんにちは' // Japan
    else if (this.order_data.country === '5d8adff0343cb83569b448af') this.welcome_text = '안녕하세요' // Korea
    else this.welcome_text = 'Hello'
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    changeCountryCity: function () {
      this.$emit('changeCountryCity')
    },
    changeDate: function () {
      this.$emit('changeDate')
    },
    changeInterest: function () {
      this.$emit('changeInterest')
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.editable-text {
  cursor: pointer;
}
.editable-text:hover {
  text-decoration: underline;
}
.editable-text.muted {
  color: #a1a1a1 !important;
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Header/Header.vue